"use client";

import type { Dispatch, SetStateAction } from "react";
import { createContext } from "react";

export type ConsentContext = {
  consent: number[];
  countryCode: null | string;
  isConsenting: boolean;
  isError: boolean;
  isLoading: boolean;
  setConsent: Dispatch<SetStateAction<number[]>>;
  setCountryCode: Dispatch<SetStateAction<null | string>>;
  setIsError: Dispatch<SetStateAction<boolean>>;

  /** TODO: remove/improve when ConsentModal/CookieManager are improved */
  isConsentModalVisible: boolean;
  saveConsent: (props: Pick<ConsentContext, "consent">) => Promise<void>;
  setIsConsentModalVisible: Dispatch<SetStateAction<boolean>>;
};

export const consentContext = createContext<ConsentContext>({
  consent: [],
  countryCode: null,
  isConsenting: false,
  isError: false,
  isLoading: true,
  setConsent: () => {},
  setCountryCode: () => {},
  setIsError: () => {},

  /** TODO: remove/improve when ConsentModal/CookieManager are improved */
  isConsentModalVisible: false,
  saveConsent: () => Promise.resolve(),
  setIsConsentModalVisible: () => {},
});
